"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCurrentUserOutputDtoSchema = exports.organizationDocumentStatusForUserSchema = exports.getCurrentUserInputDtoSchema = exports.frontendAuthSchema = exports.frontendRuleSchema = exports.currentUserMembershipSchema = exports.currentUserActorSchema = void 0;
const z = __importStar(require("zod"));
const cadstrom_shared_1 = require("@cadstrom/cadstrom-shared");
exports.currentUserActorSchema = z.object({
    userId: z.string(),
    email: z.string(),
    displayName: z.string(),
});
exports.currentUserMembershipSchema = cadstrom_shared_1.Auth.MembershipSchema;
exports.frontendRuleSchema = z.object({
    action: z.union([z.string(), z.array(z.string())]),
    subject: z.string(),
    conditions: z
        .object({
        ownerId: z.object({
            $in: z.array(z.string()),
        }),
    })
        .optional(),
});
exports.frontendAuthSchema = z.object({
    accessibleOwnerIds: z.array(z.string()),
    isStaff: z.boolean(),
    rules: z.array(exports.frontendRuleSchema),
});
exports.getCurrentUserInputDtoSchema = z
    .object({
    viewAsRole: cadstrom_shared_1.Auth.MembershipRoleSchema.optional(),
})
    .optional();
exports.organizationDocumentStatusForUserSchema = z.object({
    organizationId: z.string(),
    organizationName: z.string(),
    hasPendingDocuments: z.boolean(),
    canAccept: z.boolean(),
    isBlocked: z.boolean(),
    gracePeriodEnd: z.string().datetime().nullable(),
    pendingDocuments: z.array(z.object({
        documentType: cadstrom_shared_1.DocumentTypeSchema,
        versionId: cadstrom_shared_1.DocumentVersionIdSchema,
        name: z.string(),
        url: z.string().url(),
    })),
});
exports.getCurrentUserOutputDtoSchema = z.object({
    actor: exports.currentUserActorSchema,
    memberships: z.array(exports.currentUserMembershipSchema),
    auth: exports.frontendAuthSchema,
    documentStatus: z.array(exports.organizationDocumentStatusForUserSchema).optional(),
});
//# sourceMappingURL=get-current-user.dto.js.map